import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { SecurityBadge } from "../SecurityBadge";

const LOCALE_ROOT =
  "paywall_checkout.form.email_verification_states.password_state";

interface FooterSectionProps {
  isSubmitting: boolean;
  isSubmittingForgotPassword: boolean;
  onForgotPasswordSubmit?: () => void;
  onShowOTPForm: () => void;
}

export const FooterSection = ({
  isSubmitting,
  isSubmittingForgotPassword,
  onForgotPasswordSubmit,
  onShowOTPForm,
}: FooterSectionProps) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div className="flex justify-between sm:gap-4">
      <Button
        type="button"
        variant="link"
        onClick={onForgotPasswordSubmit}
        disabled={isSubmitting || isSubmittingForgotPassword}
        className="!px-0 underline"
      >
        <Typography.LabelSm weight="normal">
          {t([LOCALE_ROOT, "forgot_password.link"])}
        </Typography.LabelSm>
      </Button>

      <Button
        type="button"
        variant="link"
        onClick={onShowOTPForm}
        disabled={isSubmitting || isSubmittingForgotPassword}
        className="!px-0 underline"
      >
        <Typography.LabelSm weight="normal">
          {t([LOCALE_ROOT, "sign_in_with_code"])}
        </Typography.LabelSm>
      </Button>
    </div>

    <div className="flex justify-start sm:justify-end">
      <SecurityBadge />
    </div>
  </div>
);
